var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroplet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45112 0L6.60666 0.844461C6.33346 1.11767 0 7.52564 0 12.965C0 17.0631 3.35301 20.4161 7.45112 20.4161C11.5492 20.4161 14.9022 17.0631 14.9022 12.965C14.9022 7.55047 8.56879 1.11767 8.29558 0.844461L7.45112 0ZM3.72556 11.7231C4.421 11.7231 4.96742 12.2695 4.96742 12.965C4.96742 14.331 6.08508 15.4487 7.45112 15.4487C8.14656 15.4487 8.69298 15.9951 8.69298 16.6905C8.69298 17.386 8.14656 17.9324 7.45112 17.9324C4.71905 17.9324 2.48371 15.697 2.48371 12.965C2.48371 12.2695 3.03012 11.7231 3.72556 11.7231Z",
    fill: "#365644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroplet);
export default __webpack_public_path__ + "static/media/droplet.645fe5798236138d267048b5903f6b58.svg";
export { ForwardRef as ReactComponent };